(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5742],{

/***/ 65346:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assets",
      function () {
        return __webpack_require__(49806);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H$": function() { return /* binding */ WrappedTokensFlowContext; },
/* harmony export */   "hf": function() { return /* binding */ WrapperTokensFlowProvider; }
/* harmony export */ });
/* unused harmony export initValue */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_balances__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68203);
/* harmony import */ var _hooks_use_deposit_token_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74733);




const initValue = {
    selectedToken: null,
    setSelectedToken: ()=>null,
    prevTokenBalance: 0,
    tokenOptions: []
};
const WrappedTokensFlowContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(initValue);
const WrapperTokensFlowProvider = (param)=>{
    let { children  } = param;
    const { balances  } = (0,_hooks_use_balances__WEBPACK_IMPORTED_MODULE_2__/* .useBalances */ .l)();
    const [selectedToken, setSelectedToken] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { tokenOptions  } = (0,_hooks_use_deposit_token_options__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const prevTokenBalance = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!selectedToken) return 0;
        return balances[selectedToken.symbol] || 0;
    // store the previous balance based on the selectedToken, no need update when the balances are changed
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedToken
    ]);
    const ctxValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>({
            selectedToken,
            setSelectedToken,
            prevTokenBalance,
            tokenOptions
        }), [
        selectedToken,
        prevTokenBalance,
        tokenOptions
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedTokensFlowContext.Provider, {
        value: ctxValue,
        children: children
    });
};


/***/ }),

/***/ 60475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99226);
/* harmony import */ var lightweight_charts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87029);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88767);
/* harmony import */ var _hooks_use_resize_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45856);
/* harmony import */ var _providers_liquidity_chart__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98042);
/* harmony import */ var _providers_liquidity_chart_candle_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30646);
/* harmony import */ var _utils_apis_tickers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86447);
/* harmony import */ var _use_price_socket__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24240);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(80021);











const Simple24hLineChart = (param)=>{
    let { options ={} , tokenA , tokenB , onCandleListUpdated , onPriceSentFromSocket  } = param;
    const { candleWindowSize =24 , timeFrame ="one_hour"  } = options;
    const span = _utils_apis_tickers__WEBPACK_IMPORTED_MODULE_7__/* .tickerTimeFrameToSeconds */ .zI[timeFrame];
    const queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useQueryClient)();
    const [element, setElement] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [chart, setChart] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const [series, setSeries] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const { lastMessage  } = (0,_use_price_socket__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(tokenA, tokenB);
    const tokenPair = _providers_liquidity_chart_candle_utils__WEBPACK_IMPORTED_MODULE_6__/* .TokenPair.of */ .o.of(tokenA.symbol, tokenB.symbol);
    const { candles , updateAll , updateLast  } = (0,_providers_liquidity_chart__WEBPACK_IMPORTED_MODULE_5__/* .useLiquidityChart */ .Zv)(null, {
        span,
        tokenPair
    });
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        onCandleListUpdated === null || onCandleListUpdated === void 0 ? void 0 : onCandleListUpdated(candles);
        series === null || series === void 0 ? void 0 : series.setData((0,_providers_liquidity_chart__WEBPACK_IMPORTED_MODULE_5__/* .toHistogramData */ .G5)(candles.slice(-candleWindowSize), "close"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        candles,
        candleWindowSize
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!element) return;
        const chart = (0,lightweight_charts__WEBPACK_IMPORTED_MODULE_1__/* .createChart */ .C2)(element, {
            crosshair: {
                mode: lightweight_charts__WEBPACK_IMPORTED_MODULE_1__/* .CrosshairMode.Hidden */ .rM.Hidden
            },
            grid: {
                horzLines: {
                    visible: false
                },
                vertLines: {
                    visible: false
                }
            },
            layout: {
                background: {
                    color: "transparent"
                }
            },
            leftPriceScale: {
                visible: false
            },
            rightPriceScale: {
                visible: false
            },
            timeScale: {
                fixLeftEdge: true,
                fixRightEdge: true,
                visible: false
            }
        });
        setChart(chart);
        const series = chart.addLineSeries({
            baseLineWidth: 1,
            color: "#FFFFFF",
            lineWidth: 1,
            priceLineVisible: false
        });
        setSeries(series);
        series.subscribeDataChanged(()=>{
            chart.timeScale().fitContent();
        });
        (0,_providers_liquidity_chart__WEBPACK_IMPORTED_MODULE_5__/* .resizeChart */ .c2)(chart);
        let chartRemoved = false;
        queryClient.fetchQuery((0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .getQueryKeyTickers */ ._q)(tokenA, tokenB, span), ()=>(0,_utils_apis_tickers__WEBPACK_IMPORTED_MODULE_7__/* .getTickers */ .ch)(tokenA, tokenB, timeFrame), (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .getQueryOptionsTickers */ .Tp)(span)).then((tickerData)=>{
            updateAll(tickerData.candles);
            if (!chartRemoved) {
                series.setData((0,_providers_liquidity_chart__WEBPACK_IMPORTED_MODULE_5__/* .toHistogramData */ .G5)(tickerData.candles.slice(-candleWindowSize), "close"));
            }
        });
        return ()=>{
            chartRemoved = true;
            chart.remove();
            setChart(undefined);
            setSeries(undefined);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        candleWindowSize,
        element,
        span,
        timeFrame,
        tokenA,
        tokenB
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!lastMessage) return;
        onPriceSentFromSocket === null || onPriceSentFromSocket === void 0 ? void 0 : onPriceSentFromSocket(lastMessage.data);
        const mergedCandle = (0,_utils__WEBPACK_IMPORTED_MODULE_9__/* .mergeOrStartNewCandle */ .PV)(candles[candles.length - 1], lastMessage.data, span);
        updateLast(mergedCandle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lastMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const firstCandle = candles[candles.length - candleWindowSize];
        const lastCandle = candles[candles.length - 1];
        if (firstCandle && lastCandle && firstCandle.open < lastCandle.close) {
            series === null || series === void 0 ? void 0 : series.applyOptions({
                color: "#55B964"
            });
        } else if (firstCandle && lastCandle && firstCandle.open > lastCandle.close) {
            series === null || series === void 0 ? void 0 : series.applyOptions({
                color: "#FF6701"
            });
        } else {
            series === null || series === void 0 ? void 0 : series.applyOptions({
                color: "#FFFFFF"
            });
        }
    }, [
        candles,
        candleWindowSize,
        series
    ]);
    (0,_hooks_use_resize_observer__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: element,
        onResize: ()=>{
            if (chart) {
                (0,_providers_liquidity_chart__WEBPACK_IMPORTED_MODULE_5__/* .resizeChart */ .c2)(chart);
                chart.timeScale().fitContent();
            }
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        className: "w-full h-full relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            className: "absolute inset-0 pointer-events-none",
            ref: setElement
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Simple24hLineChart);


/***/ }),

/***/ 65992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bS": function() { return /* binding */ orderTokenInfosByUiQuote; }
/* harmony export */ });
/* unused harmony exports FIAT_TOKENS, orderTokensByUiQuote */
/* harmony import */ var _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27632);
/* harmony import */ var _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28309);


const FIAT_TOKENS = [
    _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__/* .REVND_MINT_ADDRESS */ .PW,
    _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__/* .RENGN_MINT_ADDRESS */ .f_
];
/**
 * Returns the ordered token pair `[base, quote]` (`1 base = X quote`) to be
 * used for rate displaying purposes.
 */ const orderTokensByUiQuote = function(defaultOrder) {
    let currentPair = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOrder;
    if (defaultOrder.length !== 2 || defaultOrder[0].equals(defaultOrder[1])) {
        throw new Error("Invalid default order pair.");
    }
    if (currentPair[0].equals(currentPair[1]) || currentPair.filter((mint)=>mint.equals(defaultOrder[0]) || mint.equals(defaultOrder[1])).length !== 2) {
        throw new Error("Invalid current pair.");
    }
    const [token0, token1] = currentPair;
    const isToken0Fiat = FIAT_TOKENS.includes(token0.toBase58());
    const isToken1Fiat = FIAT_TOKENS.includes(token1.toBase58());
    if (isToken0Fiat && isToken1Fiat) {
        return defaultOrder;
    }
    if (isToken0Fiat) {
        return [
            token1,
            token0
        ];
    }
    if (isToken1Fiat) {
        return [
            token0,
            token1
        ];
    }
    if (token0.toBase58() === _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__/* .REUSD_MINT_ADDRESS */ .Df) {
        return [
            token1,
            token0
        ];
    }
    if (token1.toBase58() === _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__/* .REUSD_MINT_ADDRESS */ .Df) {
        return [
            token0,
            token1
        ];
    }
    if (token0.toBase58() === _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__/* .RENEC_MINT_ADDRESS */ .vV) {
        return [
            token1,
            token0
        ];
    }
    if (token1.toBase58() === _hooks_use_tokens__WEBPACK_IMPORTED_MODULE_1__/* .RENEC_MINT_ADDRESS */ .vV) {
        return [
            token0,
            token1
        ];
    }
    return defaultOrder;
};
/**
 * Wrapper of {@link orderTokensByUiQuote} for {@link TokenInfo}.
 */ const orderTokenInfosByUiQuote = function(defaultOrder) {
    let currentPair = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultOrder;
    const [token0] = orderTokensByUiQuote([
        new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(defaultOrder[0].address),
        new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(defaultOrder[1].address)
    ], [
        new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(currentPair[0].address),
        new _solana_web3_js__WEBPACK_IMPORTED_MODULE_0__.PublicKey(currentPair[1].address)
    ]);
    const isFirstToken0 = currentPair[0].address === token0.toBase58();
    return [
        isFirstToken0 ? currentPair[0] : currentPair[1],
        isFirstToken0 ? currentPair[1] : currentPair[0]
    ];
};


/***/ }),

/***/ 74733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ BLACK_LIST_TOKENS_SYMBOLS; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _hooks_use_nemo_apis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67013);
/* harmony import */ var _utils_apis_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35108);



const BLACK_LIST_TOKENS_SYMBOLS = [
    "reSOL",
    "reBNB"
];
/**
 * These token options will be used in the deposit and withdraw dialog in the assets page
 */ const useDepositTokenOptions = ()=>{
    const { data: coreTokens = [] , isLoading: isFetchingCoreTokens  } = (0,_hooks_use_nemo_apis__WEBPACK_IMPORTED_MODULE_1__/* .useFetchTopCoinList */ .PE)();
    const tokenOptions = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>coreTokens.filter((token)=>!BLACK_LIST_TOKENS_SYMBOLS.includes(token.token_symbol)).map((token)=>(0,_utils_apis_helper__WEBPACK_IMPORTED_MODULE_2__/* .toRegistryTokenInfo */ .ZO)(token)), [
        coreTokens
    ]);
    return {
        tokenOptions,
        isLoading: isFetchingCoreTokens
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDepositTokenOptions);


/***/ }),

/***/ 86879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_defaults__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91747);
/* harmony import */ var lodash_defaults__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_defaults__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18446);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78718);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);





/**
 * An alternative for Next's {@link https://nextjs.org/docs/app/api-reference/functions/use-search-params | useSearchParams}
 * that supports clustering and mutating search parameters.
 */ const useMutableSearchParams = (initialParams)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [baseURI, searchParams] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const [baseURI, searchString] = router.asPath.split("?");
        return [
            baseURI,
            new URLSearchParams(searchString)
        ];
    }, [
        router.asPath
    ]);
    const [defaultParams, setDefaultParams] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(initialParams);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setDefaultParams((defaultParams)=>lodash_isEqual__WEBPACK_IMPORTED_MODULE_1___default()(defaultParams, initialParams) ? defaultParams : initialParams);
    }, [
        initialParams
    ]);
    const filterByDefaultParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((obj)=>defaultParams ? lodash_pick__WEBPACK_IMPORTED_MODULE_2___default()(obj, Object.keys(defaultParams)) : obj, [
        defaultParams
    ]);
    const params = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(()=>{
        const searchParamObj = Object.fromEntries(searchParams.entries());
        const filteredParamObj = lodash_defaults__WEBPACK_IMPORTED_MODULE_0___default()(filterByDefaultParams(searchParamObj), defaultParams);
        return new Proxy(filteredParamObj, {
            get (target, p, receiver) {
                return p in target ? Reflect.get(target, p, receiver) : null;
            }
        });
    }, [
        defaultParams,
        filterByDefaultParams,
        searchParams
    ]);
    const getMergedSearchParams = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)((stateToBeMerged)=>{
        const newSearchParams = new URLSearchParams([
            ...searchParams.entries()
        ]);
        for (const [key, value] of Object.entries(filterByDefaultParams(stateToBeMerged))){
            if (value) {
                newSearchParams.set(key, value === true ? "" : value);
            } else {
                newSearchParams.delete(key);
            }
        }
        return newSearchParams;
    }, [
        filterByDefaultParams,
        searchParams
    ]);
    const pushState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(stateToBeMerged) {
        let shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const newSearchParams = getMergedSearchParams(stateToBeMerged);
        router.push({
            pathname: baseURI,
            search: newSearchParams.toString()
        }, undefined, {
            shallow
        });
    }, [
        baseURI,
        getMergedSearchParams,
        router
    ]);
    const replaceState = (0,react__WEBPACK_IMPORTED_MODULE_4__.useCallback)(function(stateToBeMerged) {
        let shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        const newSearchParams = getMergedSearchParams(stateToBeMerged);
        router.replace({
            pathname: baseURI,
            search: newSearchParams.toString()
        }, undefined, {
            shallow
        });
    }, [
        baseURI,
        getMergedSearchParams,
        router
    ]);
    return {
        params,
        pushState,
        replaceState
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useMutableSearchParams);


/***/ }),

/***/ 49806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_nemo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/base/AssetWithdrawal/context.tsx + 2 modules
var context = __webpack_require__(40026);
// EXTERNAL MODULE: ./src/components/base/TokenPickerRevamp/context.tsx
var TokenPickerRevamp_context = __webpack_require__(71682);
// EXTERNAL MODULE: ./src/components/base/WrappedTokensFlow/context.tsx
var WrappedTokensFlow_context = __webpack_require__(96661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/use-tokens/index.ts + 1 modules
var use_tokens = __webpack_require__(28309);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/TopTokensList/view.tsx




const View = (param)=>{
    let { onClickToken , tokensList  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        direction: "row",
        gap: 2,
        flexWrap: "wrap",
        "data-testid": "quick-tokens-action",
        children: tokensList.map((token)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                gap: "6px",
                className: "bg-[#141A23] py-2 px-[12px] rounded-[10px] cursor-pointer hover:bg-[#1A2330]/70",
                onClick: ()=>onClickToken(token),
                "data-testid": "quick-token-action-".concat(token.symbol),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                        src: token.logoURI,
                        alt: token.symbol,
                        width: "24px",
                        height: "24px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm font-semibold text-white",
                        children: token.displaySymbol
                    })
                ]
            }, token.symbol))
    });
};
/* harmony default export */ var view = (/*#__PURE__*/(0,react.memo)(View));

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/TopTokensList/container.tsx




const Container = (param)=>{
    let { onClickToken  } = param;
    const { reUsdTokenInfo , tokenListMap  } = (0,use_tokens/* default */.Co)();
    const tokensList = (0,react.useMemo)(()=>{
        return [
            reUsdTokenInfo,
            tokenListMap.get(use_tokens/* REBTC_MINT_ADDRESS */.js),
            tokenListMap.get(use_tokens/* REETH_MINT_ADDRESS */.DX)
        ].filter(Boolean);
    }, [
        reUsdTokenInfo,
        tokenListMap
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(view, {
        onClickToken: onClickToken,
        tokensList: tokensList
    });
};
/* harmony default export */ var container = (Container);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/TopTokensList/index.tsx


;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalTopTokensList/container.tsx





const container_Container = ()=>{
    const { setSelectedToken  } = (0,react.useContext)(context/* AssetWithdrawalContext */.jc);
    const { setIsOpenPicker  } = (0,react.useContext)(TokenPickerRevamp_context/* TokenPickerRevampContext */.V);
    const onClickToken = (0,react.useCallback)((token)=>{
        setIsOpenPicker(false);
        setSelectedToken(token);
    }, [
        setIsOpenPicker,
        setSelectedToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        onClickToken: onClickToken
    });
};
/* harmony default export */ var WithdrawalTopTokensList_container = (container_Container);

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalTopTokensList/index.tsx


;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/DepositTopTokensList/container.tsx





const DepositTopTokensList_container_Container = ()=>{
    const { setSelectedToken  } = (0,react.useContext)(WrappedTokensFlow_context/* WrappedTokensFlowContext */.H$);
    const { setIsOpenPicker  } = (0,react.useContext)(TokenPickerRevamp_context/* TokenPickerRevampContext */.V);
    const onClickToken = (0,react.useCallback)((token)=>{
        setIsOpenPicker(false);
        setSelectedToken(token);
    }, [
        setIsOpenPicker,
        setSelectedToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        onClickToken: onClickToken
    });
};
/* harmony default export */ var DepositTopTokensList_container = (DepositTopTokensList_container_Container);

;// CONCATENATED MODULE: ./src/components/base/WrappedTokensFlow/DepositTopTokensList/index.tsx


// EXTERNAL MODULE: ./src/components/core-tokens-list/MethodSelectionDialog.tsx
var MethodSelectionDialog = __webpack_require__(63811);
// EXTERNAL MODULE: ./src/hooks/use-deposit-token-options.ts
var use_deposit_token_options = __webpack_require__(74733);
// EXTERNAL MODULE: ./src/hooks/use-settings.ts + 1 modules
var use_settings = __webpack_require__(49472);
// EXTERNAL MODULE: ./node_modules/@orca-so/common-sdk/dist/index.js
var dist = __webpack_require__(66259);
// EXTERNAL MODULE: ./src/utils/numeric.ts
var numeric = __webpack_require__(14847);
;// CONCATENATED MODULE: ./src/components/top-coins/list/helpers.ts


const TOP_COINS_TAB = {
    spot: "spot"
};
const COLUMNS_KEY = {
    index: "index",
    tokenName: "tokenName",
    balances: "balances",
    marketCap: "marketCap",
    holders: "holders",
    volume24h: "volume24h",
    diff24Hours: "24h%",
    chart: "chart",
    actionsSpot: "actionsSpot"
};
const ACTION_TYPE = {
    trade: "trade",
    withdraw: "withdraw",
    deposit: "deposit"
};
const calculateMarketCap = (token)=>{
    var _token_price, _token_metadata;
    if (!((_token_price = token.price) === null || _token_price === void 0 ? void 0 : _token_price.current_price) || !(token === null || token === void 0 ? void 0 : (_token_metadata = token.metadata) === null || _token_metadata === void 0 ? void 0 : _token_metadata.total_supply)) {
        return "--";
    }
    const currentPrice = token.price.current_price;
    const currentSupply = token.metadata.total_supply;
    return "$" + (0,numeric/* format */.WU)(dist.DecimalUtil.fromNumber(currentPrice).mul(currentSupply), 0);
};
const getTradeRoute = (tokenSymbol, isDeposit)=>{
    if (isDeposit) {
        if (tokenSymbol === "reUSD") return "/RENEC_reUSD";
        return "/reUSD_".concat(tokenSymbol);
    }
    if (tokenSymbol === "reUSD") return "/reUSD_RENEC";
    return "/".concat(tokenSymbol, "_reUSD");
};
const getColorStyle = (diffNumber)=>({
        color: diffNumber === 0 ? "white" : diffNumber < 0 ? "#FF6701" : "#55B964"
    });
const mapDataTopCoinToken = (token, tokenBalance)=>{
    var _token_metadata, _token_price, _token_chart_data, _token_price1;
    return {
        id: token.id,
        logo: token.logo_url,
        tokenMint: token.coin_address,
        tokenName: token.token_name,
        symbol: token.token_symbol,
        marketCapFormatted: calculateMarketCap(token),
        holders: ((_token_metadata = token.metadata) === null || _token_metadata === void 0 ? void 0 : _token_metadata.holders_count) ? (0,numeric/* format */.WU)(token.metadata.holders_count) : "--",
        price: ((_token_price = token.price) === null || _token_price === void 0 ? void 0 : _token_price.current_price) ? "$" + (0,numeric/* format */.WU)(token.price.current_price, 9) : "--",
        isHasChart: Number((_token_chart_data = token.chart_data) === null || _token_chart_data === void 0 ? void 0 : _token_chart_data.length) > 0,
        // diff7Days: token.price?.diff_7_days_percent || 0,
        diff24Hours: ((_token_price1 = token.price) === null || _token_price1 === void 0 ? void 0 : _token_price1.diff_24_hours_percent) || 0,
        userBalance: (0,numeric/* format */.WU)(tokenBalance || 0, {
            decimals: token.decimals,
            desiredLength: 10,
            rounding: "up"
        }),
        volume24h: !Number(token.volume_24h) ? "$0" : Intl.NumberFormat("en", {
            style: "currency",
            currency: "USD",
            notation: "compact",
            maximumSignificantDigits: 3
        }).format(Number(token.volume_24h))
    };
};

;// CONCATENATED MODULE: ./src/components/top-coins/banner/helpers.ts
const CURRENT_TYPE = {
    deposit: "deposit",
    withdraw: "withdraw"
};

// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(80437);
// EXTERNAL MODULE: ./src/components/common/ModalLayout/index.ts + 1 modules
var ModalLayout = __webpack_require__(57606);
// EXTERNAL MODULE: ./src/hooks/use-nemo-wallet.ts
var use_nemo_wallet = __webpack_require__(6200);
// EXTERNAL MODULE: ./src/hooks/useTrans.ts + 1 modules
var useTrans = __webpack_require__(39838);
// EXTERNAL MODULE: ./src/components/base/Button/index.tsx
var Button = __webpack_require__(10737);
;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalConnectWallet/index.tsx








const WithdrawalConnectWallet = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const { connectWallet  } = (0,use_nemo_wallet/* default */.Z)();
    const { selectedToken , setSelectedToken  } = (0,react.useContext)(context/* AssetWithdrawalContext */.jc);
    const handleClick = (0,react.useCallback)(()=>{
        connectWallet();
        setSelectedToken(null);
    }, [
        setSelectedToken,
        connectWallet
    ]);
    if (!selectedToken) return null;
    var _selectedToken_displaySymbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm font-semibold",
                children: trans.asset_withdrawal.you_can_trade((_selectedToken_displaySymbol = selectedToken.displaySymbol) !== null && _selectedToken_displaySymbol !== void 0 ? _selectedToken_displaySymbol : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm font-semibold mt-3 mb-[24px]",
                children: trans.asset_withdrawal.connect_first
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                "data-testid": "assets-withdraw-connect-wallet",
                onClick: handleClick,
                variant: "outlined",
                fullWidth: true,
                size: "xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-gradient",
                    children: trans.common.connect_wallet
                })
            })
        ]
    });
};
/* harmony default export */ var AssetWithdrawal_WithdrawalConnectWallet = (WithdrawalConnectWallet);

// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./src/utils/use-event-callback.ts
var use_event_callback = __webpack_require__(88095);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ExpandMore.js
var ExpandMore = __webpack_require__(6571);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button_Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(13970);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu = __webpack_require__(93419);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 3 modules
var MenuItem = __webpack_require__(23599);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 4 modules
var Select = __webpack_require__(18360);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/assets/svgs/wallet.svg
var wallet = __webpack_require__(44795);
// EXTERNAL MODULE: ./src/components/base/BaseAmountInput.tsx
var BaseAmountInput = __webpack_require__(93356);
;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalForm/SelectTokenItem.tsx



const SelectTokenItem = (param)=>{
    let { token  } = param;
    if (!token) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        className: "pl-2 py-2 pr-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadImage, {
                src: token.logoURI,
                alt: token.displaySymbol,
                width: "24px",
                height: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm font-bold",
                children: token.displaySymbol
            })
        ]
    }, token.symbol);
};
/* harmony default export */ var WithdrawalForm_SelectTokenItem = (SelectTokenItem);

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalForm/styles.ts
const selectStyles = {
    ".MuiSelect-select": {
        paddingTop: 0,
        paddingBottom: 0
    },
    "&::after": {
        content: "none"
    },
    "&::before": {
        content: "none"
    }
};

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CheckCircle.js
var CheckCircle = __webpack_require__(60888);
;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalForm/WithdrawalFormSuccess.tsx








const WithdrawalFormSuccess = (param)=>{
    let { inputAmount , tokenName , decimals , closeButtonVisibility  } = param;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: "8px",
                className: "py-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        gap: "4px",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        children: [
                            trans.asset_withdrawal.you_withdrew,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "font-semibold whitespace-nowrap",
                                "data-testid": "assets-withdraw-sent-amount",
                                children: inputAmount && (0,numeric/* formatSafe */.g1)(inputAmount, decimals)
                            }),
                            tokenName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                        className: "w-[58px] h-[58px] text-[#54B762]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: closeButtonVisibility.click,
                "data-testid": "assets-withdraw-btn-close",
                disabled: closeButtonVisibility.disabled,
                variant: "outlined",
                size: "xl",
                children: closeButtonVisibility.title
            })
        ]
    });
};
/* harmony default export */ var WithdrawalForm_WithdrawalFormSuccess = (WithdrawalFormSuccess);

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalForm/view.tsx





















const view_View = (param)=>{
    let { tokenOptions , selectedNetwork , onChangeToken , isNetworkMenuOpened , setIsNetworkMenuOpened , networkOptions , onChangeNetwork , toWalletAddress , setToWalletAddress , onInputAmountChange , selectedToken , inputAmount , isSubmitSucceeded , isLoading , submitButtonVisibility , closeButtonVisibility , currentTokenBalance , handleInputMaximumBalance , handleSubmit  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const anchorElRef = (0,react.useRef)(null);
    const isShowMenuNetwork = !isLoading && networkOptions.length > 0;
    if (isSubmitSucceeded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalForm_WithdrawalFormSuccess, {
            inputAmount: inputAmount,
            decimals: selectedToken.decimals,
            tokenName: String(selectedToken.displaySymbol),
            closeButtonVisibility: closeButtonVisibility
        });
    }
    var _selectedToken_displaySymbol;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm",
                        "data-testid": "assets-withdraw-desc-from-wallet",
                        children: trans.asset_withdrawal.you_withdrawing
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                        variant: "standard",
                        sx: selectStyles,
                        IconComponent: ExpandMore/* default */.Z,
                        value: selectedToken.symbol,
                        onChange: onChangeToken,
                        className: "rounded-[80px] overflow-hidden",
                        renderValue: (name)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalForm_SelectTokenItem, {
                                token: tokenOptions.find((token)=>token.symbol === name)
                            }),
                        "data-testid": "assets-withdraw-select-coin",
                        disabled: isLoading,
                        children: tokenOptions.map((token)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: token.symbol,
                                className: "p-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalForm_SelectTokenItem, {
                                    token: token
                                })
                            }, token.symbol))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                className: "mt-2 mb-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm",
                        children: trans.asset_withdrawal.through_network
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_Button/* default */.Z, {
                        ref: anchorElRef,
                        onClick: ()=>isShowMenuNetwork && setIsNetworkMenuOpened(true),
                        className: classnames_default()("cursor-pointer normal-case rounded-[8px] pl-3 pr-1", {
                            "bg-gradient-btn": !selectedNetwork
                        }),
                        "data-testid": "assets-withdraw-btn-select-network",
                        disabled: isLoading,
                        children: [
                            selectedNetwork ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm font-bold",
                                children: selectedNetwork.chain_name_abbr
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm",
                                children: trans.asset_withdrawal.select_network
                            }),
                            isShowMenuNetwork && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
                        ]
                    }),
                    isShowMenuNetwork && /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        anchorEl: anchorElRef.current,
                        open: isNetworkMenuOpened,
                        onClose: ()=>setIsNetworkMenuOpened(false),
                        children: networkOptions.map((network)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                value: network.chain_name,
                                className: "p-0",
                                onClick: ()=>onChangeNetwork(network),
                                "data-testid": "assets-withdraw-network-item-".concat(network.chain_name_abbr),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "px-3 py-2 text-sm font-bold",
                                    "data-testid": "assets-withdraw-network-".concat(network.chain_name_abbr),
                                    children: network.chain_name_abbr
                                })
                            }, network.chain_name))
                    })
                ]
            }),
            selectedNetwork && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-sm",
                        children: trans.asset_withdrawal.withdraw_to_wallet_address
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        className: "rounded-[8px] border border-[#3A3F5D] border-solid bg-[#060814] p-1 min-h-[44px] mt-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.ZP, {
                            "data-testid": "assets-withdraw-wallet-address",
                            id: "assets-withdraw-wallet-address-input",
                            title: "",
                            placeholder: trans.asset_withdrawal.wallet_address((_selectedToken_displaySymbol = selectedToken.displaySymbol) !== null && _selectedToken_displaySymbol !== void 0 ? _selectedToken_displaySymbol : ""),
                            value: toWalletAddress,
                            onChange: (v)=>setToWalletAddress(v.target.value),
                            required: true,
                            fullWidth: true,
                            inputProps: {
                                "aria-label": "0",
                                className: "p-1 text-sm"
                            },
                            disabled: isLoading
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        className: "mt-2",
                        "data-testid": "assets-withdraw-btn-maximum-balance",
                        onClick: handleInputMaximumBalance,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-sm",
                                children: trans.asset_withdrawal.amount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                className: "space-x-1 cursor-pointer",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: wallet/* default */.Z,
                                        alt: "wallet",
                                        width: 16,
                                        height: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        "data-testid": "assets-withdraw-token-balance",
                                        variant: "caption",
                                        className: "text-sm text-right opacity-40",
                                        children: (0,numeric/* formatSafe */.g1)(currentTokenBalance, selectedToken.decimals)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm underline cursor-pointer opacity-80 hover:opacity-100",
                                        children: "".concat(trans.common.max)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        className: "rounded-[8px] border border-[#3A3F5D] border-solid bg-[#060814] p-1 min-h-[44px] mt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseAmountInput/* default */.Z, {
                                "data-testid": "assets-withdraw-amount",
                                id: "assets-withdraw-amount-input",
                                value: inputAmount,
                                onChange: onInputAmountChange,
                                fullWidth: true,
                                decimals: (selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.decimals) || 0,
                                inputProps: {
                                    "aria-label": "0",
                                    className: "p-1 text-sm"
                                },
                                disabled: isLoading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "mr-1 text-sm",
                                children: selectedToken.displaySymbol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: handleSubmit,
                        loading: isLoading,
                        "data-testid": "assets-withdraw-btn-submit",
                        className: "mt-5",
                        size: "xl",
                        disabled: submitButtonVisibility.disabled,
                        children: submitButtonVisibility.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: closeButtonVisibility.click,
                "data-testid": "assets-withdraw-btn-close",
                disabled: closeButtonVisibility.disabled,
                className: "mt-3",
                variant: "outlined",
                size: "xl",
                children: closeButtonVisibility.title
            })
        ]
    });
};
/* harmony default export */ var WithdrawalForm_view = (/*#__PURE__*/(0,react.memo)(view_View));

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalForm/container.tsx









const WithdrawalForm_container_Container = (param)=>{
    let { onSubmit  } = param;
    const { selectedToken , setSelectedToken , currentTokenBalance , tokenOptions , networkOptions , isLoading , isSubmitSucceeded  } = (0,react.useContext)(context/* AssetWithdrawalContext */.jc);
    const trans = (0,useTrans/* default */.Z)();
    const { publicKey  } = (0,use_nemo_wallet/* default */.Z)();
    const [toWalletAddress, setToWalletAddress] = (0,react.useState)("");
    const [isNetworkMenuOpened, setIsNetworkMenuOpened] = (0,react.useState)(false);
    const [selectedNetwork, setSelectedNetwork] = (0,react.useState)(null);
    const [inputAmount, setInputAmount] = (0,react.useState)();
    const inValidInputAmountMsg = (0,react.useMemo)(()=>{
        if (!selectedToken) return trans.asset_withdrawal.issues.no_token_info;
        if (!toWalletAddress) return trans.asset_withdrawal.issues.enter_wallet_address;
        const isMissingInputAmount = !inputAmount || new decimal/* default */.Z(inputAmount).lessThanOrEqualTo(0);
        if (isMissingInputAmount) return trans.asset_withdrawal.issues.enter_amount;
        const inputAmountDecimalNumber = new decimal/* default */.Z(inputAmount);
        const isExceededBalance = inputAmountDecimalNumber.greaterThan(currentTokenBalance);
        const isInsufficientBalance = currentTokenBalance === 0;
        if (isExceededBalance || isInsufficientBalance) return trans.asset_withdrawal.issues.insufficient_balance;
        return "";
    }, [
        trans,
        currentTokenBalance,
        inputAmount,
        selectedToken,
        toWalletAddress
    ]);
    const submitButtonVisibility = (0,react.useMemo)(()=>{
        if (!publicKey) {
            return {
                disabled: false,
                title: trans.common.connect_wallet
            };
        }
        if (inValidInputAmountMsg) {
            return {
                disabled: true,
                invalidInput: true,
                title: inValidInputAmountMsg
            };
        }
        var _selectedToken_displaySymbol;
        return {
            disabled: false,
            title: trans.asset_withdrawal.withdraw_token((_selectedToken_displaySymbol = selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.displaySymbol) !== null && _selectedToken_displaySymbol !== void 0 ? _selectedToken_displaySymbol : "")
        };
    }, [
        publicKey,
        inValidInputAmountMsg,
        trans,
        selectedToken
    ]);
    const closeButtonVisibility = (0,react.useMemo)(()=>{
        if (isSubmitSucceeded) {
            return {
                disabled: false,
                title: trans.asset_withdrawal.btn_close,
                click: ()=>setSelectedToken(null)
            };
        } else {
            return {
                disabled: isLoading,
                title: trans.common.back,
                click: ()=>setSelectedToken(null)
            };
        }
    }, [
        trans,
        isLoading,
        setSelectedToken,
        isSubmitSucceeded
    ]);
    const handleInputMaximumBalance = (0,react.useCallback)(()=>{
        if (isLoading || !selectedToken || !currentTokenBalance) return;
        const newInputAmount = (0,numeric/* toDecimalSafe */.ci)(currentTokenBalance, selectedToken.decimals);
        if (newInputAmount.isFinite()) {
            setInputAmount(newInputAmount.toNumber());
        }
    }, [
        isLoading,
        selectedToken,
        currentTokenBalance,
        setInputAmount
    ]);
    const handleSubmit = (0,react.useCallback)(async ()=>{
        if (!inputAmount) return;
        await onSubmit(toWalletAddress, inputAmount);
    }, [
        onSubmit,
        toWalletAddress,
        inputAmount
    ]);
    const onInputAmountChange = (0,use_event_callback/* useEventCallback */.$)((e)=>{
        if (!e.target.value) return;
        const newInputAmount = Number(e.target.value);
        if (!Number.isNaN(newInputAmount)) setInputAmount(newInputAmount);
    });
    const onChangeToken = (0,react.useCallback)((evt)=>{
        setSelectedToken(tokenOptions.find((token)=>token.displaySymbol === evt.target.value) || null);
    }, [
        tokenOptions,
        setSelectedToken
    ]);
    const onChangeNetwork = (0,react.useCallback)((network)=>{
        setSelectedNetwork(network);
        setIsNetworkMenuOpened(false);
    }, []);
    if (!selectedToken) {
        return null;
    }
    const injectedProps = {
        selectedToken,
        selectedNetwork,
        onChangeToken,
        isNetworkMenuOpened,
        setIsNetworkMenuOpened,
        networkOptions,
        tokenOptions,
        onChangeNetwork,
        toWalletAddress,
        setToWalletAddress,
        onInputAmountChange,
        inputAmount,
        isSubmitSucceeded,
        isLoading,
        submitButtonVisibility,
        closeButtonVisibility,
        currentTokenBalance,
        handleInputMaximumBalance,
        handleSubmit
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalForm_view, {
        ...injectedProps
    });
};
/* harmony default export */ var WithdrawalForm_container = (WithdrawalForm_container_Container);

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalForm/index.ts


;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalModal/container.tsx










const classesDialog = {
    root: "outline-none p-0 h-full"
};
const WithdrawalModal_container_Container = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    const { publicKey  } = (0,use_nemo_wallet/* default */.Z)();
    const { selectedToken , setSelectedToken , submitWithdrawByRenecNetwork  } = (0,react.useContext)(context/* AssetWithdrawalContext */.jc);
    const isModalOpened = Boolean(selectedToken);
    (0,react.useEffect)(()=>{
        if (!isModalOpened) {
            setSelectedToken(null);
        }
    }, [
        setSelectedToken,
        isModalOpened
    ]);
    const modalTitle = (0,react.useMemo)(()=>{
        var _selectedToken_displaySymbol;
        return trans.asset_withdrawal.withdrawing((_selectedToken_displaySymbol = selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.displaySymbol) !== null && _selectedToken_displaySymbol !== void 0 ? _selectedToken_displaySymbol : "");
    }, [
        trans,
        selectedToken
    ]);
    const handleCloseModal = (0,react.useCallback)(()=>{
        setSelectedToken(null);
    }, [
        setSelectedToken
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        open: isModalOpened,
        onClose: handleCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
            classes: classesDialog,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLayout/* default */.Z, {
                title: modalTitle,
                onClose: handleCloseModal,
                isDisplayBtnClose: false,
                footer: trans.common.powered_by_remitano,
                children: publicKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalForm_container, {
                    onSubmit: submitWithdrawByRenecNetwork
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetWithdrawal_WithdrawalConnectWallet, {})
            })
        })
    });
};
/* harmony default export */ var WithdrawalModal_container = (WithdrawalModal_container_Container);

;// CONCATENATED MODULE: ./src/components/base/AssetWithdrawal/WithdrawalModal/index.ts


// EXTERNAL MODULE: ./src/components/base/TokenPickerRevamp/index.tsx + 6 modules
var TokenPickerRevamp = __webpack_require__(82734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
;// CONCATENATED MODULE: ./src/components/top-coins/banner/method-selection-dialog/view.tsx











const method_selection_dialog_view_View = (param)=>{
    let { isOpen , isDesktop , isDepositing , onClose , methodOptions , onClick  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const renderedContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLayout/* default */.Z, {
        title: isDepositing ? trans.common.deposit : trans.common.withdraw,
        isInsideDrawer: !isDesktop,
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            gap: "8px",
            children: methodOptions.map((method)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    gap: "8px",
                    direction: "row",
                    alignItems: "center",
                    className: "bg-[#141A23] py-5 px-4 rounded-lg cursor-pointer",
                    onClick: ()=>onClick(method.type),
                    "data-testid": method.dataTestID,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: method.title,
                            src: method.icon,
                            className: "object-cover",
                            width: 40,
                            height: 40
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "text-base font-semibold",
                                    children: method.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "text-[#9CA3AE] text-sm",
                                    children: method.description
                                })
                            ]
                        })
                    ]
                }, method.type))
        })
    });
    if (isDesktop) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            open: isOpen,
            "data-testid": "method-selection-modal",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                className: "outline-none",
                children: renderedContent
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
        open: isOpen,
        onClose: onClose,
        anchor: "bottom",
        sx: {
            ".MuiPaper-elevation": {
                backgroundColor: "transparent",
                backgroundImage: "none"
            }
        },
        "data-testid": "method-selection-drawer",
        children: renderedContent
    });
};
/* harmony default export */ var method_selection_dialog_view = (/*#__PURE__*/(0,react.memo)(method_selection_dialog_view_View));

;// CONCATENATED MODULE: ./src/components/top-coins/banner/method-selection-dialog/container.tsx








const method_selection_dialog_container_Container = (param)=>{
    let { currentType , isOpen , onClick , onClose  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const theme = (0,useTheme/* default */.Z)();
    const isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("sm"));
    const isDepositing = (0,react.useMemo)(()=>currentType === CURRENT_TYPE.deposit, [
        currentType
    ]);
    const methodOptions = (0,react.useMemo)(()=>{
        if (isDepositing) {
            return [
                {
                    title: trans.core_tokens_list.bank.deposit,
                    description: trans.core_tokens_list.bank.description,
                    type: MethodSelectionDialog/* METHOD_TYPE.bank */.z.bank,
                    dataTestID: "method-selection-bank",
                    icon: "/assets-from-bank-icon.png"
                },
                {
                    title: trans.core_tokens_list.network.deposit,
                    description: trans.core_tokens_list.network.description,
                    type: MethodSelectionDialog/* METHOD_TYPE.network */.z.network,
                    dataTestID: "method-selection-network",
                    icon: "/assets-from-others-icon.png"
                },
                {
                    title: trans.core_tokens_list.swap_with_others,
                    description: "",
                    type: MethodSelectionDialog/* METHOD_TYPE.swapOthers */.z.swapOthers,
                    dataTestID: "method-selection-swap-others",
                    icon: "/top-coins-swap-with-others.png"
                }
            ];
        }
        return [
            {
                title: trans.core_tokens_list.bank.withdraw,
                description: trans.core_tokens_list.bank.description,
                type: MethodSelectionDialog/* METHOD_TYPE.bank */.z.bank,
                dataTestID: "method-selection-bank",
                icon: "/assets-to-bank-icon.png"
            },
            {
                title: trans.core_tokens_list.network.withdraw,
                description: trans.core_tokens_list.network.description,
                type: MethodSelectionDialog/* METHOD_TYPE.network */.z.network,
                dataTestID: "method-selection-network",
                icon: "/assets-to-others-icon.png"
            }
        ];
    }, [
        isDepositing,
        trans
    ]);
    const computedProps = {
        isOpen,
        isDesktop,
        isDepositing,
        onClose,
        methodOptions,
        onClick
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(method_selection_dialog_view, {
        ...computedProps
    });
};
/* harmony default export */ var method_selection_dialog_container = (method_selection_dialog_container_Container);

;// CONCATENATED MODULE: ./src/components/top-coins/banner/method-selection-dialog/index.tsx


;// CONCATENATED MODULE: ./src/components/top-coins/banner/view.tsx





const banner_view_View = (param)=>{
    let { currentType , tokenOptions , onPickAToken , topTokensPickerSlot , isOpenMethodSelection , onCloseMethodSelection , onSelectMethod  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(method_selection_dialog_container, {
                currentType: currentType,
                isOpen: isOpenMethodSelection,
                onClose: onCloseMethodSelection,
                onClick: onSelectMethod
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPickerRevamp/* Container */.W, {
                options: tokenOptions,
                nickName: "top-coins",
                onChangeToken: onPickAToken,
                isDisplayActionView: false,
                isDisplayHighlightMessage: false,
                slot: topTokensPickerSlot
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalModal_container, {})
        ]
    });
};
/* harmony default export */ var banner_view = (/*#__PURE__*/(0,react.memo)(banner_view_View));

;// CONCATENATED MODULE: ./src/components/top-coins/banner/container.tsx















const banner_container_Container = ()=>{
    const router = (0,next_router.useRouter)();
    const { data: settingsData  } = (0,use_settings/* useSettings */.r)();
    const { fiatTokensList: tokenFiatOptions  } = (0,use_tokens/* default */.Co)();
    const [currentType, setCurrentType] = (0,react.useState)("");
    const [currentMethod, setCurrentMethod] = (0,react.useState)("");
    const { setSelectedToken: setSelectedDepositToken  } = (0,react.useContext)(WrappedTokensFlow_context/* WrappedTokensFlowContext */.H$);
    const { setSelectedToken: setSelectedWithdrawToken  } = (0,react.useContext)(context/* AssetWithdrawalContext */.jc);
    const { setIsOpenPicker  } = (0,react.useContext)(TokenPickerRevamp_context/* TokenPickerRevampContext */.V);
    const [isOpenMethodSelection, setIsOpenMethodSelection] = (0,react.useState)(false);
    const { tokenOptions: depositTokenOptions  } = (0,use_deposit_token_options/* default */.Z)();
    const onClickType = (0,react.useCallback)((newType)=>{
        setCurrentType(newType);
        setIsOpenMethodSelection(true);
    }, []);
    const onCloseMethodSelection = (0,react.useCallback)(()=>{
        setCurrentType("");
        setIsOpenMethodSelection(false);
    }, []);
    const onSelectMethod = (0,react.useCallback)((newMethod)=>{
        setIsOpenPicker(true);
        setCurrentMethod(newMethod);
        setIsOpenMethodSelection(false);
    }, [
        setIsOpenPicker
    ]);
    const tokenOptions = (0,react.useMemo)(()=>{
        if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.bank */.z.bank) {
            return tokenFiatOptions;
        }
        return depositTokenOptions;
    }, [
        currentMethod,
        depositTokenOptions,
        tokenFiatOptions
    ]);
    const onPickAToken = (0,react.useCallback)((token)=>{
        if (currentType === CURRENT_TYPE.deposit) {
            if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.bank */.z.bank) {
                router.push("/buy/".concat(token.symbol));
                return;
            }
            if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.network */.z.network) {
                setSelectedDepositToken(token);
            }
            if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.swapOthers */.z.swapOthers) {
                router.push(getTradeRoute(token.symbol, true));
                return;
            }
        }
        if (currentType === CURRENT_TYPE.withdraw) {
            if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.bank */.z.bank) {
                router.push("/sell/".concat(token.symbol));
                return;
            }
            if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.network */.z.network) {
                setSelectedWithdrawToken(token);
            }
        }
    }, [
        router,
        currentType,
        currentMethod,
        setSelectedDepositToken,
        setSelectedWithdrawToken
    ]);
    const topTokensPickerSlot = (0,react.useMemo)(()=>{
        if (currentMethod === MethodSelectionDialog/* METHOD_TYPE.network */.z.network) {
            if (currentType === CURRENT_TYPE.deposit) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositTopTokensList_container, {});
            }
            if (currentType === CURRENT_TYPE.withdraw) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawalTopTokensList_container, {});
            }
        }
        return null;
    }, [
        currentType,
        currentMethod
    ]);
    const computedProps = {
        currentType,
        tokenOptions,
        onClickType,
        onPickAToken,
        topTokensPickerSlot,
        isOpenMethodSelection,
        onCloseMethodSelection,
        onSelectMethod,
        showEuro2024Banner: Boolean(settingsData === null || settingsData === void 0 ? void 0 : settingsData.nemo_swap_assets_euro2024_token_list_enabled)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_view, {
        ...computedProps
    });
};
/* harmony default export */ var banner_container = (banner_container_Container);

;// CONCATENATED MODULE: ./src/components/top-coins/banner/index.tsx


// EXTERNAL MODULE: ./src/components/core-tokens-list/hooks/use-assets-method-selection-flow.tsx
var use_assets_method_selection_flow = __webpack_require__(65932);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/linkify-react/dist/linkify-react.es.js + 1 modules
var linkify_react_es = __webpack_require__(4913);
// EXTERNAL MODULE: ./src/components/base/AddressSpanWithCopyButton.tsx
var AddressSpanWithCopyButton = __webpack_require__(19185);
// EXTERNAL MODULE: ./src/components/base/BaseDialog.tsx + 6 modules
var BaseDialog = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(73680);
;// CONCATENATED MODULE: ./src/components/core-tokens-list/TokenDetailDialog.tsx









const TokenDetailDialog = (props)=>{
    const { handleClose , token  } = props;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseDialog/* default */.Z, {
        "data-testid": "token-detail-dialog",
        title: trans.core_tokens_list.token_detail.title,
        isOpened: true,
        handleClose: handleClose,
        body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            className: "w-[488px] px-2 max-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    alignItems: "center",
                    className: "my-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: "w-[128px] sm:w-[180px] h-[128px] sm:h-[180px] mb-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: token.logo_url,
                                alt: "reUSD",
                                width: 180,
                                height: 180,
                                className: "max-w-full rounded-full"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    className: "mr-1",
                                    fontWeight: "700",
                                    "data-testid": "token-symbol",
                                    children: token.token_symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    sx: {
                                        color: "#D0D1D8",
                                        fontSize: "0.875rem"
                                    },
                                    "data-testid": "token-name",
                                    children: [
                                        "- ",
                                        token.token_name
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressSpanWithCopyButton/* default */.Z, {
                            address: token.coin_address
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "mb-2 text-sm text-gray-300",
                            "data-testid": "description-title",
                            children: trans.core_tokens_list.table_headers.about
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            fontSize: "0.875rem",
                            overflow: "wrap",
                            "data-testid": "description",
                            className: "text-gray-100 border border-semiblack-400 rounded-md px-4 py-3 w-full bg-[#1F2A3A]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkify_react_es/* default */.Z, {
                                children: token.description
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    className: "mb-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "mb-2 text-sm text-gray-300",
                            "data-testid": "link-title",
                            children: trans.core_tokens_list.token_detail.link
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            className: "text-gray-100 border border-semiblack-400 rounded-md px-4 py-3 w-full bg-[#1F2A3A]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: (0,helpers/* getAddressUrl */.$U)(token.coin_address),
                                    target: "_blank",
                                    className: "mr-10",
                                    "data-testid": "explorer-url",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: "text-sm",
                                        children: "Explorer↗"
                                    })
                                }),
                                token.website && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: token.website,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        className: "text-sm",
                                        children: [
                                            trans.core_tokens_list.token_detail.website,
                                            "↗"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        button: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
            "data-testid": "close-btn",
            className: "normal-case rounded-lg py-[14px] border-semiblack-600",
            variant: "outlined",
            fullWidth: true,
            size: "large",
            onClick: handleClose,
            children: trans.core_tokens_list.token_detail.close
        })
    });
};
/* harmony default export */ var core_tokens_list_TokenDetailDialog = (/*#__PURE__*/(0,react.memo)(TokenDetailDialog));

// EXTERNAL MODULE: ./src/hooks/use-balances.ts
var use_balances = __webpack_require__(68203);
// EXTERNAL MODULE: ./src/hooks/use-mutable-search-params.ts
var use_mutable_search_params = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/hooks/use-nemo-apis.ts
var use_nemo_apis = __webpack_require__(67013);
// EXTERNAL MODULE: ./src/components/base/IconSearch.tsx
var IconSearch = __webpack_require__(9943);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js + 1 modules
var TableBody = __webpack_require__(295);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js + 1 modules
var TableContainer = __webpack_require__(72882);
// EXTERNAL MODULE: ./src/components/chart/simple-24h-line-chart.tsx
var simple_24h_line_chart = __webpack_require__(60475);
;// CONCATENATED MODULE: ./src/components/base/IconExport.tsx

const IconExport = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "17",
        ...props,
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.55542 7.94227L13.111 3.38672",
                stroke: "#9CA3AE",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.5556 5.60807V2.94141H10.8889",
                stroke: "#9CA3AE",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.44434 2.94141H6.33322C3.55545 2.94141 2.44434 4.05252 2.44434 6.83029V10.1636C2.44434 12.9414 3.55545 14.0525 6.33322 14.0525H9.66656C12.4443 14.0525 13.5554 12.9414 13.5554 10.1636V9.05252",
                stroke: "#9CA3AE",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var base_IconExport = (IconExport);

;// CONCATENATED MODULE: ./src/components/top-coins/list/view.token-name.tsx






const view_token_name_View = (param)=>{
    let { data  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        alignItems: "center",
        gap: "8px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: data.logo,
                alt: data.tokenName,
                className: "w-[24px] h-[24px] max-w-[24px] object-cover"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                gap: "4px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        gap: "4px",
                        alignItems: "center",
                        className: "whitespace-nowrap",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                className: "text-base text-white font-semibold lg:max-w-[130px] text-ellipsis overflow-hidden",
                                children: data.tokenName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                className: "text-[#C2CBD9] text-xs",
                                children: [
                                    " - ",
                                    data.symbol
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: (0,helpers/* getAddressUrl */.$U)(data.tokenMint),
                                target: "_blank",
                                rel: "noreferrer",
                                className: "shrink-0",
                                onClick: (evt)=>evt.stopPropagation(),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_IconExport, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: "text-xs text-[#C2CBD9]",
                        children: data.price
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var view_token_name = (/*#__PURE__*/(0,react.memo)(view_token_name_View));

// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(98102);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js + 1 modules
var TableRow = __webpack_require__(68509);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableHead/TableHead.js + 1 modules
var TableHead = __webpack_require__(53184);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js + 1 modules
var Table = __webpack_require__(7906);
;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/styles.tsx


const StyledTableCell = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
        ...props
    }))(()=>({
        "&.MuiTableCell-body": {
            color: "#fff",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            padding: "16px",
            border: "0",
            backgroundColor: "#1E2735"
        },
        "&.MuiTableCell-body:first-child": {
            paddingLeft: "24px"
        },
        "&.MuiTableCell-body:last-child": {
            paddingLeft: "24px"
        },
        "&.MuiTableCell-head": {
            color: "#C2CBD9",
            border: "0",
            fontSize: "14px",
            lineHeight: "20px",
            padding: "8px 12px"
        },
        "&.MuiTableCell-head:first-child": {
            paddingLeft: "24px"
        },
        "&.MuiTableCell-head:last-child": {
            paddingLeft: "24px"
        }
    }));
const StyledTableRow = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
        ...props
    }))(()=>({
        "&": {
            borderBottom: "1px solid rgba(255, 255, 255, 0.08)"
        },
        "&:last-child": {
            borderBottom: "0"
        }
    }));
const StyledTableHead = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
        ...props
    }))(()=>({
        "&": {
            backgroundColor: "rgba(7, 13, 21, 0.4)"
        }
    }));
const StyledTable = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
        ...props
    }))(()=>({
        "&": {
            borderRadius: "8px",
            overflow: "hidden"
        }
    }));

;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/item/view.tsx












const item_view_View = (param)=>{
    let { tokenA , tokenB , columns , data , index , onClickTokenItem  } = param;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableRow, {
        onClick: ()=>onClickTokenItem(data),
        className: "cursor-pointer",
        "data-testid": "top-coins-table-item-".concat(data.symbol),
        children: columns.map((col)=>{
            switch(col.key){
                case COLUMNS_KEY.index:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            className: "text-sm text-[#C2CBD9]",
                            children: index + 1
                        })
                    });
                case COLUMNS_KEY.balances:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: data.userBalance
                    });
                case COLUMNS_KEY.volume24h:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: data.volume24h
                    });
                case COLUMNS_KEY.tokenName:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(view_token_name, {
                            data: data
                        })
                    });
                case COLUMNS_KEY.marketCap:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: data.marketCapFormatted
                    });
                case COLUMNS_KEY.holders:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: data.holders
                    });
                case COLUMNS_KEY.diff24Hours:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            className: "text-sm font-[500]",
                            style: getColorStyle(data.diff24Hours),
                            "data-testid": "percent-24-hours",
                            children: [
                                data.diff24Hours ? (0,numeric/* format */.WU)(data.diff24Hours, {
                                    sign: true
                                }) : "0",
                                "%"
                            ]
                        })
                    });
                case COLUMNS_KEY.chart:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: tokenA && tokenB && data.isHasChart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            className: "relative min-w-[140px] w-[140px] h-[36px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                className: "absolute inset-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_24h_line_chart/* default */.Z, {
                                    options: {
                                        candleWindowSize: 168,
                                        timeFrame: "one_hour"
                                    },
                                    tokenA: tokenA,
                                    tokenB: tokenB
                                })
                            })
                        })
                    });
                case COLUMNS_KEY.actionsSpot:
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            justifyContent: "flex-end",
                            direction: "row",
                            gap: "12px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-testid": "".concat(data.symbol, "-withdraw-btn"),
                                    onClick: (evt)=>{
                                        var _col_onClick;
                                        evt.stopPropagation();
                                        (_col_onClick = col.onClick) === null || _col_onClick === void 0 ? void 0 : _col_onClick.call(col, data, ACTION_TYPE.withdraw);
                                    },
                                    className: "min-w-[90px]",
                                    variant: "outlined",
                                    size: "sm",
                                    children: trans.common.withdraw
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    "data-testid": "".concat(data.symbol, "-deposit-btn"),
                                    onClick: (evt)=>{
                                        var _col_onClick;
                                        evt.stopPropagation();
                                        (_col_onClick = col.onClick) === null || _col_onClick === void 0 ? void 0 : _col_onClick.call(col, data, ACTION_TYPE.deposit);
                                    },
                                    className: "min-w-[90px]",
                                    variant: "primary",
                                    size: "sm",
                                    disabled: true,
                                    children: trans.common.deposit
                                })
                            ]
                        })
                    });
                default:
                    return null;
            }
        })
    });
};
/* harmony default export */ var item_view = (/*#__PURE__*/(0,react.memo)(item_view_View));

;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/item/container.tsx




const item_container_Container = (param)=>{
    let { data , index , columns , onClickTokenItem  } = param;
    const { tokenListMap , reUsdTokenInfo  } = (0,use_tokens/* default */.Co)();
    const tokenA = (0,react.useMemo)(()=>{
        return tokenListMap.get(data.tokenMint);
    }, [
        tokenListMap,
        data.tokenMint
    ]);
    const tokenB = (0,react.useMemo)(()=>{
        if (data.tokenMint === reUsdTokenInfo.address) return;
        return reUsdTokenInfo;
    }, [
        data,
        reUsdTokenInfo
    ]);
    const computedProps = {
        index,
        data,
        tokenA,
        tokenB,
        columns,
        onClickTokenItem
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(item_view, {
        ...computedProps
    });
};
/* harmony default export */ var item_container = (/*#__PURE__*/(0,react.memo)(item_container_Container));

;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/item/index.tsx


// EXTERNAL MODULE: ./src/components/base/IconNoData.tsx
var IconNoData = __webpack_require__(64249);
;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/view.empty.tsx






const view_empty_View = (param)=>{
    let { colSpan  } = param;
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableRow, {
        "data-testid": "top-coins-empty-row",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTableCell, {
            colSpan: colSpan,
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNoData/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    className: "text-sm mt-2 text-[#B0B2BE]",
                    children: trans.no_data
                })
            ]
        })
    });
};
/* harmony default export */ var view_empty = (/*#__PURE__*/(0,react.memo)(view_empty_View));

// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/view.loading.tsx



const view_loading_View = (param)=>{
    let { colSpan  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableRow, {
        "data-testid": "top-coins-loading",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
            colSpan: colSpan,
            align: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
        })
    });
};
/* harmony default export */ var view_loading = (view_loading_View);

;// CONCATENATED MODULE: ./src/components/top-coins/list/desktop/index.tsx








const TopCoinsTable = (param)=>{
    let { topCoinsData , isLoading , columns , onClickTokenItem  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        "data-testid": "top-coins-table",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableHead, {
                    "data-testid": "top-coins-head",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableRow, {
                        children: columns.map((col)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableCell, {
                                children: col.label
                            }, col.key);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                    children: [
                        !isLoading && topCoinsData.map((data, idx)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(item_container, {
                                data: data,
                                index: idx,
                                columns: columns,
                                onClickTokenItem: onClickTokenItem
                            }, data.id);
                        }),
                        !isLoading && topCoinsData.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(view_empty, {
                            colSpan: columns.length
                        }),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(view_loading, {
                            colSpan: columns.length
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var desktop = (/*#__PURE__*/(0,react.memo)(TopCoinsTable));

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/MoreVert.js
var MoreVert = __webpack_require__(57976);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js + 1 modules
var Popover = __webpack_require__(14564);
// EXTERNAL MODULE: ./src/components/common/CandleChartBox.tsx
var CandleChartBox = __webpack_require__(38247);
;// CONCATENATED MODULE: ./src/components/top-coins/list/mobile/view.empty.tsx





const mobile_view_empty_View = ()=>{
    const trans = (0,useTrans/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        "data-testid": "top-coins-empty-row",
        className: "text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNoData/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                className: "text-sm mt-2 text-[#B0B2BE]",
                children: trans.no_data
            })
        ]
    });
};
/* harmony default export */ var mobile_view_empty = (mobile_view_empty_View);

;// CONCATENATED MODULE: ./src/components/top-coins/list/mobile/view.loading.tsx



const mobile_view_loading_View = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        "data-testid": "top-coins-loading",
        className: "py-6 text-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {})
    });
};
/* harmony default export */ var mobile_view_loading = (mobile_view_loading_View);

;// CONCATENATED MODULE: ./src/components/top-coins/list/mobile/view.tsx
















const mobile_view_View = (param)=>{
    let { isLoading , columnAction , topCoinsData , onOpenMoreMenu , onCloseMoreMenu , currentTargetEl , tokenInChart , setTokenAddressInChart , onOpenCandleChart , onClickTokenItem  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const isOpen = Boolean(currentTargetEl);
    const popoverId = isOpen ? "three-dots-popover" : undefined;
    const tokenMinForChart = (currentTargetEl === null || currentTargetEl === void 0 ? void 0 : currentTargetEl.getAttribute("data-token-mint-for-chart")) || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        gap: "8px",
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_view_loading, {}),
            !isLoading && topCoinsData.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_view_empty, {}),
            !isLoading && topCoinsData.map((data)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    className: "cursor-pointer rounded-lg bg-[#1F2A3A] p-4",
                    gap: "12px",
                    onClick: ()=>onClickTokenItem(data),
                    "data-testid": "top-coins-card-mobile-".concat(data.symbol),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(view_token_name, {
                                    data: data
                                }),
                                data.isHasChart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    "aria-describedby": popoverId,
                                    "data-token-mint-for-chart": data.isHasChart ? data.tokenMint : undefined,
                                    onClick: (evt)=>{
                                        evt.stopPropagation();
                                        onOpenMoreMenu(evt);
                                    },
                                    className: "rounded-lg p-0 w-[24px] h-[24px] min-w-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreVert/* default */.Z, {
                                        className: "w-[24px] h-[24px]"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            gap: "12px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    className: "flex-1",
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "text-[#9CA3AE] text-xs",
                                            children: trans.core_tokens_list.table_headers.balance
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "text-base font-bold",
                                            children: data.userBalance
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    className: "flex-1",
                                    gap: "2px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            className: "text-[#9CA3AE] text-xs",
                                            children: "24h %"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            className: "text-base font-bold",
                                            style: getColorStyle(data.diff24Hours),
                                            children: [
                                                data.diff24Hours ? (0,numeric/* format */.WU)(data.diff24Hours, {
                                                    sign: true
                                                }) : 0,
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (columnAction === null || columnAction === void 0 ? void 0 : columnAction.key) === COLUMNS_KEY.actionsSpot ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            direction: "row",
                            gap: "12px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    "data-testid": "".concat(data.symbol, "-withdraw-btn"),
                                    onClick: (evt)=>{
                                        var _columnAction_onClick;
                                        evt.stopPropagation();
                                        columnAction === null || columnAction === void 0 ? void 0 : (_columnAction_onClick = columnAction.onClick) === null || _columnAction_onClick === void 0 ? void 0 : _columnAction_onClick.call(columnAction, data, ACTION_TYPE.withdraw);
                                    },
                                    className: "flex-1 capitalize text-xs font-semibold rounded-lg p-2 min-w-[90px] border border-solid border-[#61667E] text-[#C2CBD9]",
                                    children: trans.common.withdraw
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                    "data-testid": "".concat(data.symbol, "-deposit-btn"),
                                    onClick: (evt)=>{
                                        var _columnAction_onClick;
                                        evt.stopPropagation();
                                        columnAction === null || columnAction === void 0 ? void 0 : (_columnAction_onClick = columnAction.onClick) === null || _columnAction_onClick === void 0 ? void 0 : _columnAction_onClick.call(columnAction, data, ACTION_TYPE.deposit);
                                    },
                                    className: "flex-1 capitalize text-xs font-semibold rounded-lg p-2 min-w-[90px] bg-gradient-btn",
                                    disabled: true,
                                    children: trans.common.deposit
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                                "data-testid": "".concat(data.symbol, "-do-swap-btn"),
                                onClick: (evt)=>{
                                    var _columnAction_onClick;
                                    evt.stopPropagation();
                                    columnAction === null || columnAction === void 0 ? void 0 : (_columnAction_onClick = columnAction.onClick) === null || _columnAction_onClick === void 0 ? void 0 : _columnAction_onClick.call(columnAction, data, ACTION_TYPE.trade);
                                },
                                className: "capitalize bg-gradient-btn text-xs font-semibold rounded-lg p-2 min-w-[150px]",
                                children: trans.core_tokens_list.trade
                            })
                        })
                    ]
                }, data.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                id: popoverId,
                open: isOpen,
                anchorEl: currentTargetEl,
                onClose: onCloseMoreMenu,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                classes: {
                    paper: "bg-[#141A23] rounded-lg p-2 bg-none shadow-none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                    "data-testid": "btn-open-chart-mobile",
                    onClick: (evt)=>{
                        evt.stopPropagation();
                        onOpenCandleChart(tokenMinForChart);
                    },
                    className: "text-white py-[10px] px-4 whitespace-nowrap text-sm capitalize",
                    children: trans.core_tokens_list.open_chart
                })
            }),
            tokenInChart && /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                anchor: "bottom",
                open: true,
                onClose: ()=>setTokenAddressInChart(""),
                sx: {
                    ".MuiPaper-elevation": {
                        backgroundColor: "transparent",
                        backgroundImage: "none",
                        maxHeight: "50vh"
                    }
                },
                "data-testid": "top-coins-chart-mobile",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CandleChartBox/* default */.Z, {
                    tokenIn: tokenInChart.tokenA,
                    tokenOut: tokenInChart.tokenB,
                    onHideChart: ()=>setTokenAddressInChart("")
                })
            })
        ]
    });
};
/* harmony default export */ var mobile_view = (/*#__PURE__*/(0,react.memo)(mobile_view_View));

;// CONCATENATED MODULE: ./src/components/top-coins/list/mobile/container.tsx





const mobile_container_Container = (param)=>{
    let { topCoinsData , isLoading , columns , onClickTokenItem  } = param;
    const { tokenListMap , reUsdTokenInfo  } = (0,use_tokens/* default */.Co)();
    const columnAction = (0,react.useMemo)(()=>{
        return columns.find((col)=>col.key === COLUMNS_KEY.actionsSpot);
    }, [
        columns
    ]);
    const [currentTargetEl, setCurrentTargetEl] = (0,react.useState)(null);
    const [tokenAddressInChart, setTokenAddressInChart] = (0,react.useState)("");
    const tokenInChart = (0,react.useMemo)(()=>{
        const tokenA = tokenListMap.get(tokenAddressInChart);
        if (tokenA && tokenA.address !== reUsdTokenInfo.address) {
            return {
                tokenA,
                tokenB: reUsdTokenInfo
            };
        }
        return null;
    }, [
        tokenListMap,
        tokenAddressInChart,
        reUsdTokenInfo
    ]);
    const onOpenMoreMenu = (0,react.useCallback)((event)=>{
        setCurrentTargetEl(event.currentTarget);
    }, []);
    const onCloseMoreMenu = (0,react.useCallback)(()=>{
        setCurrentTargetEl(null);
    }, []);
    const onOpenCandleChart = (0,react.useCallback)((tokenMint)=>{
        setCurrentTargetEl(null);
        setTokenAddressInChart(tokenMint);
    }, []);
    const computedProps = {
        topCoinsData,
        isLoading,
        onOpenMoreMenu,
        onCloseMoreMenu,
        columnAction,
        currentTargetEl,
        tokenInChart,
        onOpenCandleChart,
        setTokenAddressInChart,
        onClickTokenItem
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_view, {
        ...computedProps
    });
};
/* harmony default export */ var mobile_container = (mobile_container_Container);

;// CONCATENATED MODULE: ./src/components/top-coins/list/mobile/index.tsx


// EXTERNAL MODULE: ./node_modules/@mui/material/Input/Input.js
var Input = __webpack_require__(79332);
;// CONCATENATED MODULE: ./src/components/top-coins/list/styles.tsx


const StyledInput = (0,styled/* default */.ZP)((props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
        ...props
    }))(()=>({
        "&": {
            padding: "9px 8px",
            borderRadius: "8px",
            border: "1px solid #9CA3AE",
            backgroundColor: "#2E3846",
            fontSize: "14px",
            lineHeight: "20px"
        },
        "& .MuiInput-input": {
            padding: "0 0 0 8px",
            color: "#9CA3AE",
            height: "20px",
            "::placeholder": {
                color: "#9CA3AE"
            }
        }
    }));

;// CONCATENATED MODULE: ./src/components/top-coins/list/view.tsx









const list_view_View = (param)=>{
    let { columns , isLoading , isDesktop , searchName , topCoinsData , methodSelectionRendered , onChangeTab , setSearchName , onClickTokenItem  } = param;
    const trans = (0,useTrans/* default */.Z)();
    const computedCommonProps = {
        columns,
        isLoading,
        topCoinsData,
        onClickTokenItem
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        gap: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                className: "md:flex-row items-center",
                gap: "12px",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        className: "w-full md:w-auto rounded-lg p-[6.5px] bg-[#121823]/[0.32]",
                        gap: "12px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            className: "uppercase p-[8px] text-xs text-[#C2CBD9] rounded-[4px] flex-1 md:min-w-[140px] font-semibold !opacity-100 !bg-[#1E2735]",
                            onClick: ()=>onChangeTab("spot"),
                            children: trans.core_tokens_list.spot
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                        fullWidth: false,
                        disableUnderline: true,
                        placeholder: trans.core_tokens_list.search_name_placeholder,
                        startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSearch/* default */.Z, {
                            width: 20,
                            color: "#9CA3AE"
                        }),
                        className: "w-full md:w-[343px] max-w-full",
                        value: searchName,
                        onChange: (evt)=>setSearchName(evt.target.value),
                        "data-testid": "top-coins-search"
                    })
                ]
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop, {
                ...computedCommonProps
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_container, {
                ...computedCommonProps
            }),
            methodSelectionRendered
        ]
    });
};
/* harmony default export */ var list_view = (/*#__PURE__*/(0,react.memo)(list_view_View));

;// CONCATENATED MODULE: ./src/components/top-coins/list/container.tsx















const list_container_Container = ()=>{
    const router = (0,next_router.useRouter)();
    const trans = (0,useTrans/* default */.Z)();
    const theme = (0,useTheme/* default */.Z)();
    const { balances  } = (0,use_balances/* useBalances */.l)();
    const { tokenListMap  } = (0,use_tokens/* default */.Co)();
    const { params , replaceState  } = (0,use_mutable_search_params/* default */.Z)();
    const [currentTab, setCurrentTab] = (0,react.useState)(TOP_COINS_TAB.spot);
    const [searchName, setSearchName] = (0,react.useState)("");
    const isDesktop = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const [selectedTokenInfo, setSelectedTokenInfo] = (0,react.useState)();
    const { data: topCoins = [] , isLoading  } = (0,use_nemo_apis/* useFetchTopCoinList */.PE)(undefined);
    const { openDepositModal , openWithdrawModal , rendered: methodSelectionRendered  } = (0,use_assets_method_selection_flow/* default */.Z)();
    const onChangeTab = (0,react.useCallback)((newTab)=>{
        setCurrentTab(newTab);
        setSearchName("");
        replaceState({
            tab: newTab
        }, true);
    }, [
        replaceState
    ]);
    (0,react.useEffect)(()=>{
        if (params.tab && params.tab in TOP_COINS_TAB) {
            setCurrentTab(TOP_COINS_TAB[params.tab]);
        }
    }, [
        params.tab
    ]);
    const topCoinsSearched = (0,react.useMemo)(()=>{
        const searchNameFormatted = searchName.trim().toLowerCase();
        if (!searchNameFormatted) return topCoins;
        return topCoins.filter((token)=>{
            const name = token.token_name.toLowerCase();
            const symbol = token.token_symbol.toLowerCase();
            return name.includes(searchNameFormatted) || symbol.includes(searchNameFormatted);
        });
    }, [
        topCoins,
        searchName
    ]);
    const topCoinsData = (0,react.useMemo)(()=>{
        return topCoinsSearched.map((token)=>{
            return mapDataTopCoinToken(token, balances[token.token_symbol]);
        }).filter((token)=>!use_deposit_token_options/* BLACK_LIST_TOKENS_SYMBOLS.includes */.q.includes(token.symbol));
    }, [
        topCoinsSearched,
        balances
    ]);
    const onClickAction = (0,react.useCallback)((data, type)=>{
        if (type === ACTION_TYPE.trade) {
            router.push(getTradeRoute(data.symbol));
            return;
        }
        const tokenInfo = tokenListMap.get(data.tokenMint);
        if (tokenInfo && type === ACTION_TYPE.deposit) {
            openDepositModal(tokenInfo);
        }
        if (tokenInfo && type === ACTION_TYPE.withdraw) {
            openWithdrawModal(tokenInfo);
        }
    }, [
        tokenListMap,
        router,
        openDepositModal,
        openWithdrawModal
    ]);
    const columns = (0,react.useMemo)(()=>{
        return [
            {
                key: COLUMNS_KEY.index,
                label: "#"
            },
            {
                key: COLUMNS_KEY.tokenName,
                label: trans.core_tokens_list.table_headers.token_name
            },
            {
                key: COLUMNS_KEY.balances,
                label: trans.core_tokens_list.table_headers.balance
            },
            {
                key: COLUMNS_KEY.volume24h,
                label: trans.core_tokens_list.token_detail.volume_24h
            },
            {
                key: COLUMNS_KEY.diff24Hours,
                label: "24h %"
            },
            {
                key: COLUMNS_KEY.chart,
                label: trans.core_tokens_list.last_7_days
            },
            {
                key: COLUMNS_KEY.actionsSpot,
                label: "",
                onClick: onClickAction
            }
        ].flat().filter(Boolean);
    }, [
        trans,
        onClickAction
    ]);
    const onClickTokenItem = (0,react.useCallback)((data)=>{
        setSelectedTokenInfo(topCoins.find((item)=>item.coin_address === data.tokenMint));
    }, [
        topCoins
    ]);
    const onHandleCloseTokenInfo = (0,react.useCallback)(()=>{
        setSelectedTokenInfo(undefined);
    }, []);
    const computedProps = {
        isLoading,
        searchName,
        setSearchName,
        topCoinsData,
        columns,
        isDesktop,
        onChangeTab,
        onClickTokenItem,
        methodSelectionRendered
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list_view, {
                ...computedProps
            }),
            selectedTokenInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(core_tokens_list_TokenDetailDialog, {
                token: selectedTokenInfo,
                handleClose: onHandleCloseTokenInfo
            })
        ]
    });
};
/* harmony default export */ var list_container = (list_container_Container);

;// CONCATENATED MODULE: ./src/components/top-coins/list/index.tsx


;// CONCATENATED MODULE: ./src/components/top-coins/container.tsx




const top_coins_container_Container = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        className: "sm:my-10 my-6 gap-[12px] lg:gap-[30px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(banner_container, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list_container, {})
        ]
    });
};
/* harmony default export */ var top_coins_container = (top_coins_container_Container);

;// CONCATENATED MODULE: ./src/components/top-coins/index.tsx


// EXTERNAL MODULE: ./src/layouts/MainLayout/index.tsx + 24 modules
var MainLayout = __webpack_require__(33509);
;// CONCATENATED MODULE: ./src/pages/assets/index.nemo.tsx







const TopCoins = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* MainLayout */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedTokensFlow_context/* WrapperTokensFlowProvider */.hf, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* AssetWithdrawalProvider */.b2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenPickerRevamp_context/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_coins_container, {})
                })
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var index_nemo = (TopCoins);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3714,7357,6571,3419,3595,7333,7375,2054,1653,2833,2929,2107,9774,2888,179], function() { return __webpack_exec__(65346); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);